import { render, staticRenderFns } from "./PlayLottosetRoundId.vue?vue&type=template&id=0236e59e&"
import script from "./PlayLottosetRoundId.vue?vue&type=script&lang=js&"
export * from "./PlayLottosetRoundId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports